var map = {
	"./about_left.png": 5470,
	"./bottom_stats_im0.png": 4188,
	"./copy_img.png": 1386,
	"./falk_.png": 1924,
	"./fl_3.png": 1287,
	"./flying_image_0.png": 4873,
	"./flying_image_1.png": 8735,
	"./flying_image_2.png": 1212,
	"./flying_image_3.png": 1530,
	"./group_people.png": 9800,
	"./iiim.png": 3783,
	"./im_00_1.png": 7825,
	"./im_00_3.png": 8832,
	"./image_circle_01.png": 1259,
	"./img_00_2.png": 5807,
	"./img_g_1.png": 9313,
	"./lo_1.png": 1139,
	"./lo_2.png": 9773,
	"./lo_3.png": 7142,
	"./location_city.png": 9302,
	"./minobr_logo.png": 3678,
	"./mmc_logo.png": 6268,
	"./no_face.png": 4047,
	"./paper-plane.png": 947,
	"./share.png": 7317,
	"./st_p.png": 7380,
	"./st_p_1.png": 3718,
	"./stud_im.png": 8588,
	"./top_stats_im0.png": 5706,
	"./university.png": 8570,
	"./university_2.png": 981
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;